import { useMediaQuery, useTheme } from '@mui/material'

/**
 * hook to get the width for installation statement table columns in respect to the active breakpoint
 * @returns column size as a string
 */
export const useTableColumnSize = (): string => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (isMobile) {
    return 'auto'
  }

  return '250px'
}
